import React from 'react';

import Geosuggest from 'react-geosuggest';
import FadeOutErrorMessage from './FadeOutErrorMessage';

export default class ManualAddressComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      label: this.props.value || '',
      noSuggestionsError: false,
      invalidAddress: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.value !== this.props.value &&
      !nextProps.value &&
      this.state.label === this.props.value
    ) {
      this.setState({ label: nextProps.value });
    }
  }

  clearNoSuggestions() {
    if (this.state.noSuggestionsError) this.setState({ noSuggestionsError: false });
  }

  updateSuggestions(suggestions) {
    if (this.state.invalidAddress) this.setState({ invalidAddress: false });
    if (suggestions.length && this.state.label) this.clearNoSuggestions();
  }

  noSuggestions() {
    if (this._geoSuggest.input.props.value) {
      this.setState({ noSuggestionsError: true });
    }
  }

  updateLabel = (val) => {
    if (this.state.label !== val) {
      this.setState({ label: val }, () => this.props.onChange(''));
    }
    if (!val) this.setState({ noSuggestionsError: false, invalidAddress: false });
  };

  onSuggestSelect(suggestion) {
    this.setState({ invalidAddress: false });
    if (suggestion && suggestion.gmaps && suggestion.gmaps.address_components) {
      const { address_components } = suggestion.gmaps;
      let value;
      if (this.props.type === 'country') {
        value = address_components.find((obj) => obj.types.includes('country'))
          ? address_components.find((obj) => obj.types.includes('country')).long_name
          : '';
      } else if (this.props.type === 'state') {
        value = address_components.find((obj) => obj.types.includes('administrative_area_level_1'))
          ? address_components.find((obj) => obj.types.includes('administrative_area_level_1'))
              .long_name
          : '';
      } else if (this.props.type === 'city') {
        value = address_components.find((obj) => obj.types.includes('locality'))
          ? address_components.find((obj) => obj.types.includes('locality')).long_name
          : '' || address_components.find((obj) => obj.types.includes('sublocality'))
          ? address_components.find((obj) => obj.types.includes('sublocality')).long_name
          : '';
      }

      this.setState({ label: value });
      this.props.onChange(value);
      if (this._geoSuggest.input.props.value !== value) this._geoSuggest.update(value);
    }
  }

  getSuggestLabel = (suggest) => {
    return suggest.description;
  };

  skipSuggest = (suggest) => {
    const types = suggest.types || [];

    if (this.props.type === 'country' && !types.includes('country')) return true;

    if (
      this.props.type === 'state' &&
      !types.some((t) =>
        ['administrative_area_level_1', 'political', 'locality', 'geocode'].includes(t)
      )
    ) {
      return true;
    }

    if (
      this.props.type === 'city' &&
      !types.some((t) => ['locality', 'sublocality', 'neighborhood', 'political'].includes(t))
    ) {
      return true;
    }
  };

  onBlur() {
    if (!this.props.value && this.state.label) this.setState({ label: '' });
    if (this.state.noSuggestionsError || this.state.invalidAddress)
      this.setState({ noSuggestionsError: false, invalidAddress: false });
  }

  render() {
    const requiredErr = this.props.showRequiredError && this.props.required && !this.props.value;
    return (
      <div>
        <label className="input-label">
          {this.props.label} {this.props.required ? '*' : ''}
        </label>
        <Geosuggest
          inputClassName={requiredErr || this.state.invalidAddress ? 'error-input' : ''}
          queryDelay={250}
          autoComplete={'on'}
          ignoreTab={true}
          ref={(el) => (this._geoSuggest = el)}
          onBlur={this.onBlur.bind(this)}
          onChange={this.updateLabel}
          getSuggestLabel={this.getSuggestLabel}
          onUpdateSuggests={this.updateSuggestions.bind(this)}
          value={this.state.label}
          initialValue={this.state.label}
          types={
            this.props.type === 'country'
              ? ['(regions)']
              : this.props.type === 'state'
              ? ['(regions)']
              : this.props.type === 'city'
              ? ['(regions)']
              : []
          }
          skipSuggest={this.skipSuggest}
          onFocus={this.clearNoSuggestions.bind(this)}
          onSuggestSelect={this.onSuggestSelect.bind(this)}
          onSuggestNoResults={this.noSuggestions.bind(this)}
        />
        <FadeOutErrorMessage show={this.state.noSuggestionsError} message="No Suggestions" />
      </div>
    );
  }
}

//onChange, value, type (city, country, state)



// WEBPACK FOOTER //
// ./src/components/commonComponents/util/ManualAddressComponent.jsx